import React, { useEffect, useState } from "react";
import { getOptions } from "../../../helpers/options";
import { getAllRegions } from "~v2/http-request/address";
import { Row, Col, Button, Typography, Form, Select, InputNumber } from "antd";
import { PlusOutlined } from "@ant-design/icons";

const { Paragraph } = Typography;

const DaytimeTouristPHResident = () => {
  const [options, setOptions] = useState([]);
  const generateOptions = async () => {
    let data = await getAllRegions();
    if (data) {
      data = getOptions({ data, value: "regDesc", label: "regDesc" });
      return data;
    }
  };
  useEffect(() => {
    generateOptions().then((res) => setOptions(res));
  }, []);

  return (
    <>
      <Form.List name={"phResident"}>
        {(fields, { add, remove }) => (
          <>
            {fields.map(({ key, name, ...restField }, index) => (
              <Row gutter={10} justify="space-between" align="center" key={key}>
                <Col key={`inputFieldName_1`} span={12}>
                  <Paragraph level={5}>Male</Paragraph>
                </Col>
                <Col key={`inputFieldName_2`} span={12}>
                  <Paragraph level={5}>Female</Paragraph>
                </Col>

                <Col key={`inputFields_4`} span={12}>
                  <Form.Item
                    {...restField}
                    name={[name, "male"]}
                    rules={[
                      {
                        required: true,
                        message: "Please input number of male",
                      },
                    ]}
                  >
                    <InputNumber style={{ width: "100%" }} />
                  </Form.Item>
                </Col>
                <Col key={`inputFields_5`} span={12}>
                  <Form.Item
                    {...restField}
                    name={[name, "female"]}
                    rules={[
                      {
                        required: true,
                        message: "Please input number of female",
                      },
                    ]}
                  >
                    <InputNumber style={{ width: "100%" }} />
                  </Form.Item>
                </Col>

                <Col span={24}>
                  <Paragraph level={5}>
                    <center>{"Point of Origin"}</center>
                  </Paragraph>
                </Col>
                <Col span={24}>
                  <Form.Item
                    {...restField}
                    name={[name, "region"]}
                    rules={[
                      {
                        required: true,
                        message: "Please select a region!",
                      },
                    ]}
                  >
                    <Select
                      style={{ textAlign: "center" }}
                      dropdownAlign={"center"}
                      placeholder={"(Based On Region)"}
                      options={options}
                    />
                  </Form.Item>
                </Col>
                <Col span={24} style={{ marginBottom: 20 }}>
                  <center>
                    <Button
                      // block
                      danger
                      type="primary"
                      size="middle"
                      onClick={() => remove(index)}
                    >
                      Remove Record
                    </Button>
                  </center>
                  {/* <CloseCircleOutlined
                    style={{
                      color: COLORS.red,
                      fontSize: 20,
                      margin: "10px 0 10px 0",
                    }}
                    onClick={() => remove(index)}
                  /> */}
                </Col>
              </Row>
            ))}
            <Row style={{ marginBottom: 50 }}>
              <Button
                block
                onClick={() => add()}
                type="primary"
                icon={<PlusOutlined />}
              >
                ADD MORE
              </Button>
            </Row>
          </>
        )}
      </Form.List>
    </>
  );
};

export default DaytimeTouristPHResident;
